<template>
  <el-main class="main-con el-main">
    <router-view />
  </el-main>
</template>

<script>
    export default {
        name: "CustomerDebtorUser"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/DebtorUser.vue